module.exports = __webpack_public_path__ + "8e63be4c59714081627b2097c4662fbe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Roboto-Bold-webfont.svg
// module id = 72
// module chunks = 0